let Environment = {
  presale: {
    name: "Tiga",
    detailPage: "tiga",
    symbol: "TIGA",
    apiTag: "TIGA",
    apiUrl: "users/buy-tiga",
    image: "https://gems.vip/assets/alldetailpages/tiga/main-img.png",
  },

  // MAINNET
  presaleContract: "0xeecccfd9a1cbf9871f8b9d2e0b8d329faa7246a7", //presale mainnet
  nftPurchase: "0x1119c2d708E42Fb591FCe77283b0791a135855ba",
  busd: "0xdac17f958d2ee523a2206206994597c13d831ec7",
  tomi: "0x4385328cc4D643Ca98DfEA734360C0F596C83449",
  instituson: "0x3d48992a2b04337905040CfD73e8d5e80Eeb2ab9",
  eth: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
  usdc: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
  wbtc: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
  link: "0x514910771af9ca656af840dff83e8264ecf986ca",
  pepe: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
  unisape: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
  gems: "0x3010ccb5419F1EF26D40a7cd3F0d707a0fa127Dc",
  dop: "0x97a9a15168c22b3c137e6381037e1499c8ad0978",

  GemsStaking: "0x6A1aa5ac35f38Bdb25BBD976E8eca942b23260b2",
  GemsStaking1: "0x80c162BD592F58ece113404BEfD5Dd24fdF35A49",
  GemsSubscription: "0x80c162BD592F58ece113404BEfD5Dd24fdF35A49",
  rpc: "https://cold-responsive-friday.quiknode.pro/15bbbcf85ec27b075486f39524c5741f49222932/",
  privateSaleGraph:
    "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/tigagraph/prod/gn", //mainnet presale graph
  institionSaleGraph:
    "https://api.studio.thegraph.com/query/75549/institution-main-graph/version/latest",
  gemsLockingGraph:
    "https://api.studio.thegraph.com/query/74755/staking-index/001",
  gemsSubscribeGrap:
    "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/subscription-mainnet-graph/v0.0.1-new-version/gn", //mainnet graph
  gemSubscriptionMultiple:
    "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/subscription-V2-main/v0.0.1-new-version/gn", //mainnet graph

  // // TESTNET
  // presaleContract: "0x9b35F4bf2DFC85f2e1eF9C0bAA5a37066832EaaA", //presale testnet
  // busd: "0x6fEA2f1b82aFC40030520a6C49B0d3b652A65915",
  // tomi: "0x84f0bC91f23649c76139d402a1c00c6aC19A4400",
  // eth: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
  // wbtc: "0x54410d42628C7fD6720C489219033345Bcb7Cc73",
  // usdc: "0x25762231808F040410586504fDF08Df259A2163c",
  // pepe: "0x0592EBa69Aa5f2eF68d9cb740fBaB2c0c0CC6A91",
  // link: "0x37bBd68526C9BDb49f18fB36983701E344f2A163",
  // unisape: "0x079c46A5Ba477400a326E03Ad8D22FaBeaE57b4F",
  // dop: "0xa048e46c35cf210bb0d5bb46b2dd06828ef17893",
  // gems: "0x7ddd14e3a173a5db7bb8fd74b82b667f221492b9",

  // GemsStaking: "0x034f504F34330eA87dcc8aBae2935eac9fD2eFaE",
  // GemsStaking1: "0xe7Ad3a7EC2fdc8aa141dB9AFc1f701AAb579DA85",
  // GemsSubscription: "0xe7Ad3a7EC2fdc8aa141dB9AFc1f701AAb579DA85",

  // privateSaleGraph:
  //   "https://api.studio.thegraph.com/query/112168/tigagraph/version/latest", //testnet presale graph
  // institionSaleGraph:
  //   "https://api.studio.thegraph.com/query/75549/institution-main-graph/version/latest",
  // gemsLockingGraph:
  //   "https://api.studio.thegraph.com/query/74755/staking-index/001",
  // gemsSubscribeGrap:
  //   "https://api.studio.thegraph.com/query/75549/subscription-graph/version/latest",
  // gemSubscriptionMultiple:
  //   "https://api.studio.thegraph.com/query/80537/subscription-v2/version/latest",
};

export default Environment;
